import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-regulamento-indicacao',
  templateUrl: './modal-regulamento-indicacao.component.html',
  styleUrls: ['./modal-regulamento-indicacao.component.scss']
})
export class ModalRegulamentoIndicacaoComponent {
  @Input() modoConfirmacao: boolean = false;

  constructor(public modal: NgbActiveModal) {}
}


